module.exports = __webpack_public_path__ + "static/media/eina04-regular.fff53266.woff2";